import React from "react";
import { ExpandableTextContent } from "../../../../shadcn/components/custom/ExpandableTextContent";
import { Card } from "../../../../shadcn/components/ui/card";

interface PDPropertyDescriptionPropsInterface {
  description: string;
  details?: { label: string; value: string }[];
}

export const PDPropertyDescription: React.FC<
  PDPropertyDescriptionPropsInterface
> = ({ description, details }) => {
  return (
    <Card className="bg-white shadow-card-shadow p-4 border-none rounded-[10px]">
      <ExpandableTextContent
        title="Property Description"
        textContent={description}
      />
      <div className="gap-y-4 sm:gap-x-6 grid grid-cols-1 sm:grid-cols-2 mt-6">
        {details?.map((detail, index) => (
          <p
            key={`PD_Detail_${detail.label}_${index}`}
            className="text-sm capitalize"
          >
            <span className="font-medium text-brand-secondaryTextLabelGrey">
              {detail.label}:{" "}
            </span>
            <span className="mt-1 font-normal text-brand-primaryTextDarkGrey">
              {detail.value}
            </span>
          </p>
        ))}
      </div>
    </Card>
  );
};
